export const LOGO_FULL_FALLBACK = "/logo.png";
